enum OrgaoEmissaoCpfSNGPC {
    CRA = 1,
    CRE = 2,
    CREA = 3,
    CRF = 4,
    DGPC = 5,
    DPF = 6,
    IDAMP = 7,
    IFP = 8,
    IN = 9,
    JUNTA = 10,
    MAER = 11,
    MEX = 12,
    MM = 13,
    OAB = 14,
    SEJSP = 15,
    SES = 16,
    SESP = 17,
    SJS = 18,
    SJTC = 19,
    SSIPT = 20,
    SSP = 21,
    VACIV = 22,
    VAMEN = 23,
    PM = 24,
    ITB = 25,
    CRM = 26,
    CBM = 27,
    DIC = 28,
    CFP = 29,
    CRO = 30,
    COREN = 31,
    CFN = 32,
    MRE = 33,
    CRCI = 34,
    CRB = 35,
    CRN = 36,
    CFE = 37,
    CRC = 38,
    CRP = 39,
    CRQ = 40,
    ANVISA = 41,
    GOVEST = 42,
    PREF = 43,
    CRBM = 44,
    IPF = 45,
    CREFITO = 46,
    CRMV = 47,
    MTE = 48,
    CRFA = 49,
    CORECON = 50,
    SDS = 51,
    SRF = 52
}

export default OrgaoEmissaoCpfSNGPC;

